import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const DeleteTicketValidationSchema = z.object({
  ticketId: z.string({ message: 'Ticket ID is required' }).min(1),
});
export type TDeleteTicketValidation = z.infer<typeof DeleteTicketValidationSchema>;
export type TDeleteTicketPayload = TDeleteTicketValidation;
export type TDeleteTicketResponse = ApiResponse<{
  message: string;
}>;

export const deleteTicket = (payload: TDeleteTicketPayload): Promise<TDeleteTicketResponse> => {
  const url = `/ticket/${payload.ticketId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Space Admin React-Query Hook
 */
type UseDeleteTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteTicket, AxiosErrorCustom>;
};

export const useDeleteTicketMutation = ({ mutationConfig }: UseDeleteTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: deleteTicket,
    ...restConfig,
  });
};
